import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type PasswordResetCodeEmailSerializer = {
  resetCode: string;
  email: string;
  message: string;
};

export type PostPasswordResetCodeEmailPayloadType = (
  Pick<PasswordResetCodeEmailSerializer, 'resetCode'>
);
export type PostPasswordResetCodeEmailResponseType = (
  Pick<PasswordResetCodeEmailSerializer, 'email' | 'message'>
);

export const apiFetchPasswordResetCodeEmail = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostPasswordResetCodeEmailPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.passwordResetCodeEmail(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
